import React from 'react';
import {HomepageSection, HomepageSectionHeader} from '../Homepage';


class Imprint extends React.Component {
  render() {
    return (
      <HomepageSection style={{position: 'relative', zIndex: 2}}>
        <HomepageSectionHeader>
          <h2><span>{'Imprint '}</span></h2>
        </HomepageSectionHeader>
        <div style={{marginTop: 25, marginBottom: 25}}>

          <p>
            <b>The European Society for Immunodeficiencies (ESID)</b> is a non-profit organization whose main
            objectives are to facilitate the exchange of ideas and information among doctors, nurses, biomedical
            investigators, patients and their families concerned with primary immunodeficiency diseases and also to
            promote research on causes, mechanisms and treatment of these disorders. ESID was established as an
            informal group in 1983 and became a society in 1994.
          </p>


          <p>
            The ESID Society is registered with the Chamber of Commerce in Leiden, the Netherlands ("Kamer van
            Koophandel Rijnland") with the number 40448576.</p>
          <p>
            While we have made every effort to ensure that the information contained in this site has been obtained
            from reliable sources ESID is not responsible for any errors or omissions, or for the results obtained
            from the use of this information. All information in this site is provided "as is", with no guarantee of
            completeness, accuracy, timeliness or of the results obtained from the use of this information.</p>
          <p>
            ESID respects the privacy of users of this site.</p>
          <p>
            The distribution of any content of this webpage is not allowed unless ESID gave you permission.</p>
          <p>Data on our website is computed based on our registry database and merged with statistics of affiliated centers - errors reserved!</p>
        <p>
            Certain information such as type of browser used, type of system software and domain name of the
            provider
            used, information that is not personal is routinely saved in a protocol file by the ESID web server for
            internal use only.</p>
          <p>
            This website contains links to other websites. ESID makes no representations as to the accuracy or any
            other aspect of information contained in other websites.</p>
          <h2>Responsible for the contents of these pages:</h2>
          <p>
            Mikko Sepp&auml;nen<br/>
            Chief Physician<br/>
            MD, PhD, Specialist in Internal Medicine and Infectious Diseases, Adjunct Professor<br/>
            University HUS Hospital, Children and Helsinki Adolescents, Rare Disease Center<br/>
            Majakka, P.O.Box 281, 00029 HUS | Sten&auml;ckinkatu 11, Helsinki<br/>
            E-mail: mikko.seppanen@hus.fi<br/>
            Tel.: +358 50 4279606
          </p>
        </div>
      </HomepageSection>
    );
  }
}

export default Imprint;


// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/Imprint.js